export const API_TYPES = {
  AUTH: "auth",
  SAKUSAS: "sakusas",
};

export const API_APP_NAMES = {
  SAKUSAS: "express_sakusas",
};
